
import React, { useState, useEffect } from 'react';
import { Box, CircularProgress, Button, List } from '@material-ui/core';
import { useTranslate, useDataProvider, Loading } from 'react-admin';
import PageListLabel from '../page-list-label';
import DevicesTable from './devicesTable';
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes';
import SubItem from './SubItem';
import Search from '../search';
import Snackbar from '../common/snackbar';

export const DeviceList = ({ readOnly, roomData }) => {
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const [loading, setLoading] = useState(false);
    const [loadingPage, setLoadingPage] = useState()
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false)
    const [devicesAssign, setDevicesAssign] = useState([]);
    const [devices, setDevices] = useState([]);
    const [filterDevice, setFilterDevice] = useState("")
    const [totalCount, setTotalCount] = useState(0);
    const [search, setSearchText] = useState('');
    const [openDropBox, setOpenDropBox] = useState(false)
    const [fullAssign, setFullAssign] = useState(false)
    const [randomNumber, setRandomNumber] = useState(Math.random());
    let sort = {
        field: 'ipAddress',
        order: 'DESC'
    };
    let pagination = {
        page: 1,
        perPage: 10
    };
    const theme = useSelector((state) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );

    const getDeviceAssigned = () => {
        dataProvider('GET_LIST', "devicesbyroom", {
            filter: {
                room: roomData.id
            },
            pagination: {},
            sort: {},
        }).then(({ data, total }) => {
            let countAssign = data.filter(value => value.room !== null).length
            setFullAssign(countAssign >= 6)
            const dataWithStatus = data.map(item => {
                return {
                    ...item,
                    status: 'Offline',
                    red: true
                }
            });
            setDevicesAssign(dataWithStatus)
            // getStatusAssign(dataWithStatus)
            getListDevices();
            setLoadingPage(false)
        }).catch(error => {
            setLoadingPage(false)
        });
    }

    const action = (
        <Button color="secondary" size="small" onClick={() => {
            setSuccess(false)
        }}>
            {translate('resources.room.close')}
        </Button>
    );

    const getListDevices = () => {
        // let filter = {
        //     or: [
        //         { room: roomData.id },
        //         { room: null }
        //     ]
        // }
        // if (filterDevice.trim() && filterDevice.length > 0) {
        //     filter = {
        //         and: [
        //             {
        //                 or: [
        //                     { room: roomData.id },
        //                     { room: null }
        //                 ]
        //             },
        //             {
        //                 or: [
        //                     { name: { contains: filterDevice.trim() } },
        //                     { id: { contains: filterDevice.trim() } },
        //                     { serialNumber: { contains: filterDevice.trim() } }
        //                 ],
        //             }
        //         ]
        //     };
        // }

        dataProvider('GET_LIST', "devices/unassign", {
            filter: { search: { contains: filterDevice.trim() } },
            pagination,
            sort,
        }).then(({ data, total }) => {
            var tempDevices = data.slice()
            if (devicesAssign !== undefined && devicesAssign.length > 0) {
                devicesAssign.forEach(value => {
                    let index = tempDevices.findIndex(element => element.id === value.id)
                    if (index > 0)
                        tempDevices[index].room = roomData.id
                })
            }
            setDevices(tempDevices);
            setTotalCount(total);
            setLoadingPage(false)
        }).catch(error => {
            setLoadingPage(false)
        });
    }

    const onGetListDevices = (sortObj, paginationObj) => {
        pagination = paginationObj;
        sort = sortObj;
        getListDevices();
    }

    const handleOnChangeCheckBoxAssign = id => (event) => {
        let tempArrayAssign = devicesAssign.slice()
        let tempArray = devices.slice()

        let indexAsign = tempArrayAssign.findIndex(value => value.id === id)
        let index = tempArray.findIndex(value => value.id === id)

        tempArrayAssign[indexAsign].room = !event.target.checked ? null : roomData.id
        if (index > -1) {
            tempArray[index].room = tempArrayAssign[indexAsign].room
        }
        let countAssign = tempArrayAssign.filter(value => value.room !== null).length
        setFullAssign(countAssign >= 6)


        setDevicesAssign(tempArrayAssign)
        setDevices(tempArray)
    }

    const handleOnChangeCheckBox = id => (event) => {
        let tempArray = devices.slice()
        let index = tempArray.findIndex(value => value.id === id)
        var tempArrayAssign = devicesAssign.slice()
        if (event.target.checked) {
            tempArray[index].room = roomData.id

            if (!tempArrayAssign.find(value => value.id === tempArray[index].id))
                tempArrayAssign.push(tempArray[index])
            else {
                let i = tempArrayAssign.findIndex(value => value.id === tempArray[index].id)
                tempArrayAssign[i].room = roomData.id
            }
            setDevicesAssign(tempArrayAssign)
        }
        else {
            tempArray[index].room = null
            let tempArrayAssign = devicesAssign.slice()
            let i = tempArrayAssign.findIndex(value => value.id === tempArray[index].id)
            tempArrayAssign[i].room = null
            setDevicesAssign(tempArrayAssign)
        }
        let countAssign = tempArrayAssign.filter(value => value.room !== null).length
        setFullAssign(countAssign >= 6)
        setDevices(tempArray)
    }

    const onChangFilter = (value) => {
        setFilterDevice(value)
    }

    const handleOnSave = () => {
        var requests = []
        setLoading(true)
        devicesAssign.forEach(value => {
            requests.push(dataProvider('UPDATE', "device/assign", {
                id: value.id,
                data: {
                    room: value.room
                }
            }))
        })
        Promise.all(requests)
            .then(() => {
                setSuccess(true)
                setLoading(false)
                setOpenDropBox(false)
                getDeviceAssigned()
                setTimeout(() => {
                    setSuccess(false);
                }, 5000);
            })
            .catch(() => {
                setError(translate('resources.room.saveFailed'))
                setLoading(false)
                setOpenDropBox(false)
            }
            )

    }

    // const getStatusAssign = (devicesAssign) => {
    //     const temps = devicesAssign.slice();
    //     const arrayMac = [];
    //     devicesAssign.forEach((value) => {
    //         arrayMac.push(value.id)
    //     });
    //     if (arrayMac.length > 0) {
    //         dataProvider('CREATE', "devices/getstatus", {
    //             data: {
    //                 macs: arrayMac
    //             }

    //         }).then(({ data }) => {
    //             data.forEach((item, index) => {
    //                 if (!item.status || item.status === 1) {
    //                     temps[index].status = translate(`pos.dashboard.offline`)
    //                     temps[index].red = true;
    //                     temps[index].green = false;
    //                 } else {
    //                     temps[index].status = translate(`pos.common.online`)
    //                     temps[index].red = false;
    //                     temps[index].green = true;
    //                 }
    //             });
    //             setDevicesAssign(temps);
    //         });
    //     }
    // }

    useEffect(() => {
        getListDevices();
        getDeviceAssigned();
    }, []);

    // useEffect(() => {
    //     if (devicesAssign.length > 0) {
    //         getStatusAssign(devicesAssign)
    //     }
    // }, [randomNumber]);

    // useEffect(() => {
    //     getStatusAssign(devicesAssign)
    //     setInterval(() => {
    //         setRandomNumber(Math.random());
    //     }, 5000);
    // }, []);

    if (loadingPage) return <Loading />
    if (!devices || !devicesAssign) return null
    return (
        <Box py={2} m='auto'>
            {
                success && (
                    <Box width='100%' display='flex' justifyContent='flex-end'>
                        <Box width='40%'>
                            <Snackbar
                                show={success}
                                message={translate('resources.room.saveSuccess')}
                                onClose={() => setSuccess(false)}
                            />
                        </Box>

                    </Box>
                )
            }
            <PageListLabel
                buttonHidden={true}
                searchHidden={true}
                label={translate('pos.devices.name')}
                searchPlaceholder={translate('pos.devices.search')}
                btnText={translate('pos.devices.create')}
                onChangeText={setSearchText}
                getList={getListDevices}
            />
            <DevicesTable
                readOnly={readOnly}
                fullAssign={fullAssign}
                data={devicesAssign}
                total={totalCount}
                getListDevices={onGetListDevices}
                handleOnChangeCheckBox={handleOnChangeCheckBoxAssign}
            />
            <Box display='flex' width="100%" mt={3}>
                <Box width='60vw'>
                    <SubItem
                        name="Un-assigned devices"
                        subColor={theme.palette.primary.main}
                        open={openDropBox}
                        handleClick={() => {
                            setOpenDropBox(!openDropBox)
                        }}>
                        <Box my={1} ml={1}>
                            <Search placeholder='search device' onChangeText={onChangFilter} getList={getListDevices}></Search>
                        </Box>

                        {/* <FilterInput name='search' value={filterDevice} onChangeValue={onChangFilter} /> */}
                        <List component="div" disablePadding>
                            <DevicesTable
                                readOnly={readOnly}
                                fullAssign={fullAssign}
                                isPaging={true}
                                hiddenHeader={true}
                                style='secondary'
                                data={devices}
                                total={totalCount}
                                getListDevices={onGetListDevices}
                                handleOnChangeCheckBox={handleOnChangeCheckBox}
                            />
                        </List>
                    </SubItem>
                </Box>
            </Box>

            <Box width='100%' display='flex' mt={1}>
                <Button
                    disabled={readOnly}
                    onClick={handleOnSave}
                    variant="contained" color='primary' size='large'>
                    {loading && (
                        <CircularProgress
                            size={25}
                            thickness={2}
                            color='inherit'
                        />
                    )}
                    {translate('resources.room.save')}
                </Button>
            </Box>

        </Box>
    );
}

export default DeviceList;